const EXCEPTIONS = {
  UserNotFound: 'UserNotFoundException',
  MFAMethodNotFound: 'MFAMethodNotFoundException',
  NotAuthorized: 'NotAuthorizedException',
  UsernameExists: 'UsernameExistsException',
  UnknownError: 'UnknownError',
  PasswordResetRequired: 'PasswordResetRequiredException',
  InvalidParameter: 'InvalidParameterException',
  ExpiredCode: 'ExpiredCodeException',
  InvalidCode: 'CodeMismatchException',
  LimitExceeded: 'LimitExceededException'
}

const LOGIN_STATES = {
  AUTHENTICATED: 'AUTH',
  NEW_PASS_REQ: 'NEW_PASSWORD_REQUIRED',
  MFA_REQ: 'MFA_REQUIRED',
  TOTP_REQ: 'SOFTWARE_TOKEN_MFA'
}

export {
  EXCEPTIONS,
  LOGIN_STATES
}
